<template>
  <svg v-if="isSelected" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15" fill="var(--bs-secondary)" stroke="var(--bs-primary)" stroke-width="2" />
    <path
      d="M13.2492 19.8225L9.42667 16L8.125 17.2925L13.2492 22.4167L24.2492 11.4167L22.9567 10.1242L13.2492 19.8225Z"
      fill="white" />
  </svg>
  <svg v-else width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15" fill="white" stroke="var(--bs-primary)" />
  </svg>
</template>

<script setup>
  defineProps({
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  });
</script>

<style lang="css"></style>
